<script setup>
import { onBeforeUnmount, onBeforeMount, reactive } from "vue";
import { useStore } from "vuex";
import { useRoute } from "vue-router";
import { Form, ErrorMessage } from "vee-validate";
import axios from "axios";
import { passwordRecoverySchema } from "./schemas/passwordRecoverySchema"; // Asegúrate de tener el esquema de validación adecuado
import Navbar from "@/examples/PageLayout/Navbar.vue";
import ArgonInput from "@/components/ArgonInput.vue";
const body = document.getElementsByTagName("body")[0];
import { useLoading } from "vue-loading-overlay";
import Swal from "sweetalert2";
const API_URL = process.env.VUE_APP_API_URL;

const route = useRoute();
const token = route.query.token; // Obtener el token de la URL
console.log("Token recibido:", token);
const $loading = useLoading();


const formData = reactive({
  token: token,
  password: "",
  password2: "",
});

const store = useStore();
onBeforeMount(() => {
  store.state.hideConfigButton = true;
  store.state.showNavbar = false;
  store.state.showSidenav = false;
  store.state.showFooter = false;
  body.classList.remove("bg-gray-100");
});
onBeforeUnmount(() => {
  store.state.hideConfigButton = false;
  store.state.showNavbar = true;
  store.state.showSidenav = true;
  store.state.showFooter = true;
  body.classList.add("bg-gray-100");
});

const recoverPassword = () => {

  const loader = $loading.show({
    color: "#6418a8",
    backgroundColor: "#ffffff",
  });
  // Realizar la solicitud PUT para actualizar el registro del solicitud
  try {
    axios
      .post(API_URL + "recovery-password", formData)
      .then((response) => {
        loader.hide();
        // Verificar si la solicitud fue exitosa
        if (response.data.status === true) {
          Swal.fire({
            icon: "success",
            title: "Éxito",
            text: response.data.message,
          }).then(() => {
            route.push("/login");
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: response.data.message,
          });
        }
      })
      .catch(() => {
        loader.hide();
      });
  } catch (err) {
    loader.hide();
  }
};
// const recoverPassword = () => {
//   console.log("Recuperando contraseña...", formData);
//   store
//     .dispatch("auth/recoverPassword", formData)
//     .then((res) => res)
//     .then((data) => {
//       if (data.status === true) {
//         Swal.fire({
//           icon: "success",
//           title: "Éxito",
//           text: "Se ha enviado un correo de recuperación a tu dirección de correo electrónico.",
//         });
//       }
//     })
//     .catch((err) =>
//       Swal.fire({
//         icon: "error",
//         title: "Oops...",
//         text: err.response.data.error,
//       })
//     );
// };
</script>

<template>
  <div class="container top-0 position-sticky z-index-sticky">
    <div class="row">
      <div class="col-12">
        <navbar
          isBlur="blur border-radius-lg my-3 py-2 start-0 end-0 mx-4 shadow"
          v-bind:darkMode="true"
          isBtn="bg-gradient-success"
        />
      </div>
    </div>
  </div>
  <main class="mt-0 main-content">
    <section>
      <div class="page-header min-vh-100">
        <div class="container">
          <div class="row">
            <div
              class="mx-auto col-xl-4 col-lg-5 col-md-7 d-flex flex-column mx-lg-0"
            >
              <div class="card card-plain">
                <div class="pb-0 card-header text-start">
                  <h4 class="font-weight-bolder">Recuperación de Contraseña</h4>
                  <p class="mb-0">
                    Introduzca su nueva contraseña para ingresar al sistema
                  </p>
                </div>
                <div class="card-body">
                  <Form
                    ref="formPasswordRecovery"
                    :validation-schema="passwordRecoverySchema"
                    @submit="recoverPassword"
                  >
                    <div class="mb-3">
                      <argon-input
                        v-model="formData.password"
                        name="password"
                        type="password"
                        placeholder="Contraseña"
                      />
                      <ErrorMessage name="password" />
                    </div>
                    <div class="mb-3">
                      <argon-input
                        v-model="formData.password2"
                        name="password2"
                        type="password"
                        placeholder="Repetir Contraseña"
                      />
                      <ErrorMessage name="password2" />
                    </div>
                    <div class="text-center">
                      <button type="submit" class="btn btn-primary btn-block">
                        <span>Recuperar Contraseña</span>
                      </button>
                    </div>
                  </Form>
                </div>
              </div>
            </div>
            <div
              class="top-0 my-auto text-center col-6 d-lg-flex d-none h-100 pe-0 position-absolute end-0 justify-content-center flex-column"
            >
              <div
                class="position-relative bg-gradient-primary h-100 m-3 px-7 border-radius-lg d-flex flex-column justify-content-center overflow-hidden"
                style="
                  background-image: url(&quot;https://raw.githubusercontent.com/creativetimofficial/public-assets/master/argon-dashboard-pro/assets/img/signin-ill.jpg&quot;);
                  background-size: cover;
                "
              >
                <span class="mask bg-gradient-custom opacity-6"></span>
                <h4
                  class="mt-5 text-white font-weight-bolder position-relative"
                >
                  "La atención es la nueva moneda"
                </h4>
                <p class="text-white position-relative">
                  Cuanto más fácil parece escribir, más esfuerzo ha puesto el
                  escritor en el proceso.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>
